import PropTypes from 'prop-types';
import React from 'react';

import OrderCheckoutProduct from '../../../../../models/order/checkout/OrderCheckoutProduct';
import { modelOf } from '../../../../../prop-types';
import QuantityFieldGroup from '../../../../common/QuantityFieldGroup';
import FieldError from '../../../../form/FieldError';

const CheckoutCartProductQuantity = ({
  product,
  quantityField,
  disabled,
  onUpdateProductQuantity,
  onBlur,
  onFocus,
  customError,
}) => (
  <div className="CheckoutCartProductRow__quantity">
    <div className="form-inline">
      <QuantityFieldGroup
        key={product.id}
        className="AddToCart__quantity-group"
        disabled={disabled}
        field={quantityField}
        defaultValue={Number(quantityField.value)}
        maxQuantity={99999}
        quantityStep={product.getQuantityStep()}
        unit={product.unitName}
        onUpdateProductQuantity={onUpdateProductQuantity}
        onBlur={onBlur}
        onFocus={onFocus}
      />
    </div>
    <FieldError field={quantityField} customError={customError} />
    {product.package_info && (
      <div
        className="CheckoutCartProductRow__package_info"
        dangerouslySetInnerHTML={{ __html: product.package_info }}
      />
    )}
  </div>
);

CheckoutCartProductQuantity.propTypes = {
  product: modelOf(OrderCheckoutProduct).isRequired,
  quantityField: PropTypes.object.isRequired,
  disabled: PropTypes.bool.isRequired,
  onUpdateProductQuantity: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  customError: PropTypes.string,
};

export default CheckoutCartProductQuantity;
